import { useState, useEffect } from 'react';
import { useFetchWrapper } from '_helpers';

// Thin API layer over useFetchWrapper that understands the server's RES_FORM envelope
// ({ status, message }). Mutations return { ok, data, error }; never throws.
export function useApi() {
    const fw = useFetchWrapper();

    async function handle(res) {
        let json = {};
        try { json = await res.json(); } catch (_) { /* non-JSON */ }
        const success = res.ok && (json.status === 'Success' || json.status === 'Logged In Success');
        if (success) return { ok: true, data: json.message, status: res.status };
        const msg = typeof json.message === 'string'
            ? json.message
            : (json.message && json.message.description) || 'Đã xảy ra lỗi, vui lòng thử lại';
        return { ok: false, error: msg, status: res.status, data: json.message };
    }

    return {
        get:   async (path) => handle(await fw.get(path, null, null)),
        post:  async (path, body) => handle(await fw.post(path, 'application/json', JSON.stringify(body))),
        put:   async (path, body) => handle(await fw.put(path, 'application/json', JSON.stringify(body))),
        patch:  async (path, body) => handle(await fw.patch(path, 'application/json', JSON.stringify(body || {}))),
        delete: async (path) => handle(await fw.delete(path, null, null)),
    };
}

// GET-on-mount hook. `path` carries any query string, so changing month/year re-fetches.
// Returns { data, loading, error, refetch }.
export function useFetch(path) {
    const api = useApi();
    const [tick, setTick] = useState(0);
    const [state, setState] = useState({ data: null, loading: true, error: null });

    useEffect(() => {
        let alive = true;
        setState(s => ({ ...s, loading: true }));
        api.get(path).then(r => {
            if (!alive) return;
            if (r.ok) setState({ data: r.data, loading: false, error: null });
            else setState({ data: null, loading: false, error: r.error });
        });
        return () => { alive = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [path, tick]);

    return { ...state, refetch: () => setTick(t => t + 1) };
}
